
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.854 4.67l1.188 7.791c.481 3.41-1.887 6.511-5.094 6.539H5.21C2.06 19-.336 15.87.173 12.461l1.189-7.79C1.644 2.095 3.785.11 6.4 0h6.415c2.615.11 4.756 2.095 5.039 4.67zm-11.926.888c.005 2.01 1.65 3.638 3.68 3.643 2.03-.005 3.674-1.633 3.68-3.643 0-.387-.318-.7-.708-.7a.704.704 0 00-.708.7A2.253 2.253 0 019.608 7.8a2.253 2.253 0 01-2.265-2.242c0-.387-.316-.7-.707-.7a.704.704 0 00-.708.7z","fill":"#7B01B5"}})])
          )
        }
      }
    